module.exports = __webpack_public_path__ + "static/headerRightBg375-481c27651b99bf34764e75fda7f4fec0.png";